module.exports = __webpack_public_path__ + "static/media/Meda - Orange_PW Pink.43e64890.jpg";